{
  "id": 45,
  "location": "paris",
  "difficulty": "hard",
  "moves": 23,
  "kinds": 6,
  "goals": [
    { "type": "stain" },
    { "type": "mud" },
    { "type": "collect", "kind": "latte", "count": 40 }
  ],
  "stars": [5070, 6280],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . X . . X . .",
    ". . . . . . . .",
    "~. ~. ~. ~. ~. ~. ~. ~.",
    "~. ~. ~. ~. ~. ~. ~. ~.",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.49, "movesLeft": 4, "closeLosses": 0.22, "target": 0.42 }
}
